export default function turboPrepareBeforeCache() {
  // Hide navbar toggler using vanilla JavaScript instead of jQuery
  const navbarToggler = document.getElementById('navbarToggler');
  if (navbarToggler) {
    navbarToggler.style.display = 'none';
  }
}
